<template>
  <Modal
    @closed="$emit('close')"
    id="modal-chat-templates"
    class="vlw_chatTemplates"
    :open="true"
    :closable="true"
    title="Chat Templates"
  >
    <div class="chat-templates-container">
      <p class="template-description">
        Selecteer een template om snel een standaardbericht te versturen.
      </p>

      <div class="search-wrapper">
        <span
          class="vl-icon vl-vi vl-vi-search search-icon"
          aria-hidden="true"
        ></span>
        <input
          type="text"
          v-model="search"
          class="vl-input-field search-input"
          placeholder="Zoeken op trefwoord"
        />
      </div>

      <ul class="template-list">
        <li
          v-for="({ body }, index) in filteredTemplates"
          :key="index"
          class="template-item"
        >
          <span
            role="button"
            tabindex="0"
            @click.prevent="$emit('select', body)"
          >
            {{ body }}
          </span>
        </li>

        <li v-if="filteredTemplates.length === 0" class="no-templates">
          <span
            class="vl-icon vl-vi vl-vi-info-circle no-templates-icon"
            aria-hidden="true"
          ></span>
          <p>Er zijn geen chat templates gevonden.</p>
        </li>
      </ul>
    </div>
  </Modal>
</template>

<script>
export default {
  name: 'ChatTemplates',
  props: ['templates'],
  data() {
    return {
      search: '',
    };
  },
  computed: {
    filteredTemplates() {
      const term = this.search.toLowerCase();

      return this.templates
        .filter(({ body }) => body.toLowerCase().includes(term))
        .sort((a, b) => {
          // If order values exist and are numbers, sort numerically
          if (a.order !== undefined && b.order !== undefined) {
            return a.order - b.order;
          }

          // Fallback to alphabetical sort by body
          return a.body.localeCompare(b.body);
        });
    },
  },
  mounted() {
    console.log('ChatTemplates: ', this.templates);
  },
};
</script>

<style scoped lang="scss">
.vlw_chatTemplates {
  // scrollbar styles
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #cbd2da;
    border-radius: 10px;
    border: 2px solid transparent;
    background-clip: content-box;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #a5b4c4;
  }

  // Firefox support
  scrollbar-width: thin;
  scrollbar-color: #cbd2da transparent;

  .chat-templates-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 900px;
  }

  .search-wrapper {
    position: relative;
    width: 100%;

    .search-icon {
      position: absolute;
      top: 55%;
      left: 1rem;
      transform: translateY(-50%);
      color: #999;
      font-size: 1.4rem;
      pointer-events: none;
    }

    .search-input {
      width: 100%;
      padding-left: 3rem;
    }
  }

  .template-description {
    margin-bottom: 0.2rem;
  }

  .template-list {
    list-style: none;
    padding: 0;
    margin: 0;
    min-height: 300px;
    max-height: 500px;
    overflow-y: auto;
    border: 1px solid #e0e6ed;
    border-radius: 6px;
  }

  .template-item {
    border-bottom: 2px solid #f0f3f8;

    margin-bottom: 0;

    &:not(:last-child) {
      margin-bottom: 2px;
    }

    &:last-child {
      border-bottom: none;
    }

    span {
      cursor: pointer;
      display: block;
      padding: 0.75rem 1rem;

      &:hover {
        background-color: #05c;
        color: #fff;
      }
    }
  }

  .no-templates {
    padding: 10rem;
    text-align: center;
    color: #888;

    .no-templates-icon {
      font-size: 4rem;
      margin-bottom: 1rem;
      color: #ccc;
    }
  }
}
</style>
